<template>
    <div class="container-fluid">
        <div class="row project-cards">
            <div class="col-sm-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6">
                                <h3>Patrones</h3>
                            </div>
                            <div class="col-md-6">
                                <button class="btn btn-primary" style="float: right; margin-bottom: 30px;" type="button" data-bs-toggle="modal" data-bs-target=".store-employer-modal" @click="clearForm()">Nuevo Patrón</button>
                            </div>
                            <div class="col-lg-4 col-md-6" v-for="(employer,index) in employers" :key="index" >
                                <div class="project-box">
                                    <button class="btn btn-xs btn-danger" style="float: right; padding-top: 2px;" type="button" data-bs-toggle="modal" data-bs-target=".delete-employer-modal" @click="deleteEmployer(employer)">Eliminar</button>
                                    <button class="btn btn-xs btn-warning" style="float: right; padding-top: 2px; margin-right: 5px;" type="button" data-bs-toggle="modal" data-bs-target=".update-employer-modal" @click="editEmployer(employer)">Editar</button>
                                    <h6>{{employer.name}}</h6>
                                    <div class="d-flex mb-3">
                                        <div class="flex-grow-1 project-box-item">
                                            <p>{{employer.rfc}}</p>
                                        </div>
                                    </div>
                                    <div class="employees" v-if="false">
                                        <ul>
                                            <li class="d-inline-block"><img class="img-30 rounded-circle" src="@/assets/images/user/7.jpg" alt="" data-original-title="" title=""></li>
                                            <li class="d-inline-block"><img class="img-30 rounded-circle" src="@/assets/images/user/7.jpg" alt="" data-original-title="" title=""></li>
                                            <li class="d-inline-block"><img class="img-30 rounded-circle" src="@/assets/images/user/7.jpg" alt="" data-original-title="" title=""></li>
                                            <li class="d-inline-block ms-2">
                                                <p class="f-12">+5 Empleados</p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade store-employer-modal" tabindex="-1" role="dialog" aria-labelledby="storeEmployerModalLabel"aria-hidden="true">
            <StoreEmployerModal ref="storeEmployerModal" @store="refreshEmployers"/>
        </div>
        <div class="modal fade update-employer-modal" tabindex="-1" role="dialog" aria-labelledby="updateEmployerModalLabel"aria-hidden="true">
            <UpdateEmployerModal ref="updateEmployerModal" @update="refreshEmployers"/>
        </div>
        <div class="modal fade delete-employer-modal" tabindex="-1" role="dialog" aria-labelledby="deleteEmployerModalLabel"aria-hidden="true">
            <DeleteEmployerModal ref="deleteEmployerModal" @delete="refreshEmployers"/>
        </div>
    </div>
</template>

<script>
import StoreEmployerModal from "@/components/tmkt/employers/store_modal.vue"
import UpdateEmployerModal from "@/components/tmkt/employers/update_modal.vue"
import DeleteEmployerModal from "@/components/tmkt/employers/delete_modal.vue"

import ws from '@/services/employers'

export default {
    name: 'employers',
    components: {
        StoreEmployerModal,
        UpdateEmployerModal,
        DeleteEmployerModal
    },
    data(){
        return{
            employers: []
        }
    },
    mounted: async function() {
        let response = await ws.getEmployers(); 

        if(response.type == "success"){
            this.employers = response.data;
        }
    },
    methods: {
        refreshEmployers(employers){
            this.employers = employers;
        },
        async editEmployer(data) {
            this.$refs.updateEmployerModal.setEmployer(data);
        },
        async deleteEmployer(data) {
            this.$refs.deleteEmployerModal.setEmployer(data);
        },
        async clearForm() {
            this.$refs.storeEmployerModal.clearForm();
        },
    }
}

</script>

<style scoped>
    .project-cards {
        padding-top: 30px;
    }
</style>